import React from 'react';
import { graphql } from 'gatsby';
import { Meta } from 'react-head';

import BlogPost from '../../03-organisms/BlogPost/BlogPost';
import OrderKitOrUploadDataSection from '../../04-templates/OrderKitOrUploadDataSection/OrderKitOrUploadDataSection';
import SEO from '../../01-atoms/SEO/SEO';
import withStructuredData from '../../../HOCs/withStructuredData';

const Page = ({ data, location, pageContext: { openGraphImageUrl } }) => {
  const {
    post: {
      body,
      fields: { readingTime },
      frontmatter: {
        canonical_url_override,
        categories,
        date_published,
        description,
        embeddedImagesLocal,
        embeddedImagesRemote,
        featured_image,
        meta_description_override,
        meta_title_override,
        tags,
        title,
      },
      tableOfContents,
    },
  } = data;

  return (
    <>
      <SEO
        canonical={canonical_url_override}
        description={meta_description_override || description}
        location={location}
        title={meta_title_override || title}
      />

      <Meta content="article" name="og:type" />

      <Meta content={openGraphImageUrl} name="twitter:image" />
      <Meta content={openGraphImageUrl} name="og:image" />
      <Meta content="1200" name="og:image:width" />
      <Meta content="630" name="og:image:height" />

      {!!categories?.length && (
        <>
          <Meta content="Category" name="twitter:label2" />
          <Meta content={categories[0]} name="twitter:data2" />
        </>
      )}

      {!!readingTime?.text && (
        <>
          <Meta content="Read time" name="twitter:label1" />
          <Meta
            content={readingTime.text.replace(`read`, `⏱️`)}
            name="twitter:data1"
          />
        </>
      )}

      <BlogPost
        body={body}
        date_published={date_published}
        description={description}
        embeddedImagesLocal={embeddedImagesLocal}
        embeddedImagesRemote={embeddedImagesRemote}
        image={featured_image}
        tableOfContents={tableOfContents}
        tags={tags}
        title={title}
      />

      <OrderKitOrUploadDataSection semanticLevel={2} />
    </>
  );
};

export const query = graphql`
  query($slug: String) {
    post: mdx(fields: { slug: { eq: $slug } }) {
      body
      fields {
        readingTime {
          text
        }
        slug
      }
      frontmatter {
        categories
        description
        date_published(formatString: "MMMM DD, YYYY")
        embeddedImagesRemote {
          childImageSharp {
            gatsbyImageData(layout: CONSTRAINED)
          }
        }
        embeddedImagesLocal {
          childImageSharp {
            gatsbyImageData(layout: CONSTRAINED)
          }
        }
        featured_image {
          alt
          src {
            childImageSharp {
              gatsbyImageData(
                height: 450
                width: 450
                placeholder: TRACED_SVG
                layout: CONSTRAINED
              )
            }
          }
        }
        tags
        title
        meta_title_override
        meta_description_override
        canonical_url_override
      }
      tableOfContents
    }
    site {
      siteMetadata {
        siteUrl
      }
    }
  }
`;

export default withStructuredData(Page);
